import { Box, Typography } from '@mui/material';
import type { LegendProps } from 'recharts';

type MetricChartLegendProps = Pick<LegendProps, 'payload' | 'formatter'>;

export const MetricChartLegend = ({ payload, formatter }: MetricChartLegendProps) =>
  payload?.length ? (
    <Box justifyContent='center' display='flex' gap={2}>
      {payload.map((legend, index) => (
        <Box key={legend.value} display='flex' alignItems='center' gap={1}>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: 0.5,
              backgroundColor: legend.color,
            }}
          />
          <Typography variant='body2' color='text.secondary'>
            {formatter ? formatter(legend.value, legend, index) : legend.value}
          </Typography>
        </Box>
      ))}
    </Box>
  ) : null;
